import styled from 'styled-components'

const Title = styled.h1`
   text-align: center;
   padding: 2rem 0;
   margin-bottom: 1rem;
`

export default Title
